import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';
import '../styles/CallToAction.css';

const CallToAction = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="cta-section">
      <div className="section-container">
        <h2>{t.ctaTitle}</h2>
        <div className="cta-links">
          <a href="#" className="cta-link">{t.joinCommunity}</a>
          <a href="#" className="cta-link">{t.buildWithUs}</a>
          <a href="#" className="cta-link">{t.followMission}</a>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;